// extracted by mini-css-extract-plugin
export default {"profileBlockLabel":"account-sponsor-flow_profileBlockLabel__lCrWg","root":"account-sponsor-flow_root__SDF0t"};